// @flow
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Newsletter from 'components/newsletter/Newsletter';
import type { DispatchProps, StateProps } from 'components/newsletter/Newsletter';
import { fetchArticlesStaticCategories } from 'actions/newsletterActions';
import { fetchGenericSidebar } from 'actions/sidebarActions';
import type { DispatchType, StateType } from 'types/Actions';
import { fetchPageList } from 'actions/pageActions';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      status: state.newsletterState.status,
      settingsStatus: state.settingsState.status,
      organization: state.settingsState.title,
      news: state.newsletterState.articles,
      sidebar: state.sidebarState,
      categoriesArticle: state.newsletterState.categoriesArticle,
      banniere: state.settingsState.banniere,
      placeholder: state.settingsState.placeholder,
      template: state.pageListState,
      title: state.pageListState.title,
      featured_media: state.pageListState.featured_media,
      rencontresLive: state.rencontreLiveState.rencontres ? Object.keys(state.rencontreLiveState.rencontres).length : 0,
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchArticlesStaticCategories: () => dispatch(fetchArticlesStaticCategories()),
      fetchGenericSidebar: () => dispatch(fetchGenericSidebar()),
      fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
    })
  )(Newsletter)
);
